module.exports = 2;


/*****************
 ** WEBPACK FOOTER
 ** ./runtime/module-caching/two.js
 ** module id = 3
 ** module chunks = 1
 **/